export default {
  setDocumentsData(state, documents) {
    state.documents = documents;
  },
}
